import { useState } from "react";
import { UploadFile } from "./UploadFile";
import styles from "./UploadImage.module.css";

const TABS = [
  // {
  //   name: "Banners",
  //   color: "#2563eb",
  //   keyPrefix: "EPASS1", // DB column
  //   fileBaseName: "EPASS", // CDN file base → EPASS1.jpg, EPASS2.jpg, EPASS3.jpg
  //   folder: "EPASS",
  //   mode: "banner",
  //   maxImages: 3,
  // },
  {
    name: "Firm Logo",
    color: "#ea580c",
    keyPrefix: "EPASS2",
    folder: "EPASS",
    mode: "logo",
  },
  // {
  //   name: "E Catelog Banners",
  //   color: "#01856f",
  //   keyPrefix: "ECAT_IMAGE",
  //   fileBaseName: "ecatimage", 
  //   folder: "ECATALOG",
  //   mode: "banner",
  // },
  // {
  //   name: "Ecat Explore Images",
  //   color: "#7c3aed",
  //   keyPrefix: "ECAT_EXPLOREIMAGES", 
  //   fileBaseName: "ecatexplore", 
  //   folder: "ECATALOG",
  //   mode: "banner",
  //   maxImages: 4, 
  // },
];

export const UploadImage = () => {
  const [active, setActive] = useState(TABS[0].name);
  const activeColor = TABS.find((t) => t.name === active).color;

  return (
    <div className={styles.page} style={{ "--page-color": activeColor }}>
      <div className={styles.tabs}>
        {TABS.map((tab) => (
          <button
            key={tab.name}
            style={{ "--tab-color": tab.color }}
            className={`${styles.tab} ${active === tab.name ? styles.tabActive : ""}`}
            onClick={() => setActive(tab.name)}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {TABS.map((tab) => (
        <div
          key={tab.name}
          style={{ display: active === tab.name ? "block" : "none" }}
        >
          <UploadFile
            title={`Upload ${tab.name}`}
            accent={tab.color}
            keyPrefix={tab.keyPrefix}
            fileBaseName={tab.fileBaseName}
            folder={tab.folder}
            mode={tab.mode}
            maxImages={tab.maxImages}
          />
        </div>
      ))}
    </div>
  );
};